const classikThumbs = [...document.querySelectorAll('.pdp-thumb')];
const classikPhoto = document.querySelector('#pdp-main-photo');
let classikPhotoIndex = 0;

function showClassikPhoto(index) {
  const nextIndex = (index + classikThumbs.length) % classikThumbs.length;
  if (nextIndex === classikPhotoIndex) return;
  const next = classikThumbs[nextIndex];
  classikPhotoIndex = nextIndex;
  (window.BasicProductImages ? window.BasicProductImages.setImage(classikPhoto, next.dataset.src) : (classikPhoto.removeAttribute('srcset'), classikPhoto.src = next.dataset.src));
  classikPhoto.alt = next.dataset.alt;
  classikThumbs.forEach((thumb, i) => {
    const selected = i === nextIndex;
    thumb.classList.toggle('is-active', selected);
    thumb.setAttribute('aria-pressed', String(selected));
  });
}
classikThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showClassikPhoto(index)));
document.querySelector('#pdp-photo-prev').addEventListener('click', () => showClassikPhoto(classikPhotoIndex - 1));
document.querySelector('#pdp-photo-next').addEventListener('click', () => showClassikPhoto(classikPhotoIndex + 1));

let classikTouchX = null;
const classikMainImage = document.querySelector('#pdp-main-image');
classikMainImage.addEventListener('touchstart', event => { classikTouchX = event.changedTouches[0].screenX; }, {passive:true});
classikMainImage.addEventListener('touchend', event => {
  if (classikTouchX === null) return;
  const difference = event.changedTouches[0].screenX - classikTouchX;
  if (Math.abs(difference) > 45) showClassikPhoto(classikPhotoIndex + (difference < 0 ? 1 : -1));
  classikTouchX = null;
}, {passive:true});

const classikOptions = [...document.querySelectorAll('input[name="classik-format"]')];
const classikOffers = [...document.querySelectorAll('input[name="classik-offer"]')];
const classikQuantityInput = document.querySelector('#classik-quantity-input');
const classikVariantInput = document.querySelector('#classik-variant-id');
const classikTotal = document.querySelector('#classik-total');
const classikStickySize = document.querySelector('#classik-sticky-size');
const classikStickyPrice = document.querySelector('#classik-sticky-price');
const classikForm = document.querySelector('#classik-cart-form');

function classikMoney(amount) { return 'CHF ' + amount + '.–'; }
function classikOfferPrice(unitPrice, quantity) {
  if (quantity === 3) return unitPrice * 3 - 3;
  if (quantity === 6) return unitPrice * 5;
  return unitPrice;
}

function updateClassikPurchase() {
  const selected = classikOptions.find(option => option.checked);
  const offer = classikOffers.find(option => option.checked);
  const unitPrice = Number(selected.dataset.price);
  const quantity = Number(offer.value);
  const total = classikOfferPrice(unitPrice, quantity);
  const size = selected.value + ' g';
  classikOptions.forEach(option => option.closest('.pdp-variant').classList.toggle('is-selected', option === selected));
  classikOffers.forEach(option => option.closest('.classik-offer').classList.toggle('is-selected', option === offer));

  classikVariantInput.value = selected.dataset.variant;
  classikVariantInput.setAttribute('value', selected.dataset.variant);
  classikQuantityInput.value = String(quantity);
  classikQuantityInput.setAttribute('value', String(quantity));

  [1, 3, 6].forEach(count => {
    const offerPrice = classikOfferPrice(unitPrice, count);
    document.querySelector('#classik-offer-price-' + count).textContent = classikMoney(offerPrice);
    if (count > 1) {
      document.querySelector('#classik-offer-compare-' + count).textContent = classikMoney(unitPrice * count);
      document.querySelector('#classik-offer-savings-' + count).textContent = 'Économie ' + classikMoney(unitPrice * count - offerPrice);
    }
  });

  const contents = quantity === 1
    ? '1 pot de ' + size
    : quantity === 3
      ? '3 pots de ' + size
      : '6 pots de ' + size + ' · 5 payés, 1 offert';
  document.querySelector('#classik-selection-summary').textContent = contents;
  document.querySelector('#classik-selection-price').textContent = classikMoney(total);
  const saving = unitPrice * quantity - total;
  const savingMessage = document.querySelector('#classik-selection-saving');
  savingMessage.hidden = saving === 0;
  savingMessage.textContent = saving ? 'Tu économises ' + classikMoney(saving) + ' sur les produits, par rapport à ' + classikMoney(unitPrice * quantity) + ' pour ' + quantity + ' pots à l’unité (hors livraison).' : '';
  document.querySelector('#classik-add-label').textContent = quantity === 1 ? 'Ajouter mon pot' : 'Ajouter mes ' + quantity + ' pots';
  classikTotal.textContent = classikMoney(total);
  classikStickySize.textContent = size + ' · ' + quantity + ' ' + (quantity === 1 ? 'pot' : 'pots');
  classikStickyPrice.textContent = classikMoney(total);
}

classikOptions.forEach(option => option.addEventListener('change', updateClassikPurchase));
classikOffers.forEach(option => option.addEventListener('change', updateClassikPurchase));
classikForm.addEventListener('submit', updateClassikPurchase);
updateClassikPurchase();

const classikSticky = document.querySelector('#pdp-mobile-buy');
const classikClosing = document.querySelector('.pdp-closing');
function updateClassikSticky() {
  const buyBox = classikForm.getBoundingClientRect();
  const passedBuyBox = buyBox.bottom < 82;
  const nearEnd = classikClosing.getBoundingClientRect().top < window.innerHeight * .82;
  const visible = window.innerWidth <= 700 && passedBuyBox && !nearEnd && !document.body.classList.contains('menu-locked');
  classikSticky.classList.toggle('is-visible', visible);
  classikSticky.setAttribute('aria-hidden', String(!visible));
  classikSticky.inert = !visible;
}
window.addEventListener('scroll', updateClassikSticky, {passive:true});
window.addEventListener('resize', updateClassikSticky);
new MutationObserver(updateClassikSticky).observe(document.body, {attributes:true,attributeFilter:['class']});
updateClassikSticky();
